import axios from 'axios';
import { BASE_URL } from '../../Constants';
import { announceOrgInactive, announcePlanBlocked, announcePlanStale, isOrgInactiveResponse, isPlanBlockedResponse, isPlanMutation } from '../../utils/planEvents';

const api = axios.create({
  baseURL: BASE_URL,
});

const zohoApiHelper = axios.create({
  baseURL: process.env.REACT_APP_ZOHO_BASE_URL
})

zohoApiHelper.interceptors.request.use((config) => {
  const token = localStorage.getItem('zoho_access_token');
  if (token) {
    config.headers['Authorization'] = `Zoho-oauthtoken ${token}`;
  }
})

api.interceptors.request.use((config) => {
  const isZohoRequest = config.url?.includes('recruit.zoho.com');

  let token;

  if (isZohoRequest) {
    token = localStorage.getItem('zoho_access_token');
    if (token) {
      config.headers['Authorization'] = `Zoho-oauthtoken ${token}`;
    }
  } else {
    token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  }

  // ngrok's free tier returns an HTML warning page instead of the API response unless this header is set
  const requestUrl = `${config.baseURL || ''}${config.url || ''}`;
  if (requestUrl.includes('ngrok')) {
    config.headers['ngrok-skip-browser-warning'] = 'true';
  }

  return config;
});

// Plan limits can come back from jobs, uploads, interviews and invites. One place turns them into
// the upgrade / "choose a plan" prompt; the caller still receives the rejection for its own handling.
api.interceptors.response.use(
  (response) => {
    if (isPlanMutation(response)) announcePlanStale();
    return response;
  },
  (error) => {
    if (isOrgInactiveResponse(error)) announceOrgInactive();
    if (isPlanBlockedResponse(error)) {
      const { code, error: message, details } = error.response.data;
      announcePlanBlocked({ code, message, metric: details?.metric || null });
    }
    return Promise.reject(error);
  }
);

export default api;
export {zohoApiHelper}
